import { useEffect, useState, type RefObject } from 'react';

/**
 * Detects whether an element's text content overflows its container (is truncated via CSS ellipsis).
 * Re-evaluates whenever `deps` change. Does NOT use ResizeObserver — matches table-builder behavior.
 */
export function useIsOverflowing(ref: RefObject<HTMLElement | null>, deps: unknown[] = []): boolean {
  const [isOverflowing, setIsOverflowing] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const el = ref.current;
    if (el) {
      setIsOverflowing(el.scrollWidth > el.clientWidth);
    } else {
      setIsOverflowing(false);
    }
  }, deps);

  return isOverflowing;
}
